import $ from 'jquery'
import webUtils from '@/commons/utils/web.utils'

let _BASE_PROTOCOL = location.protocol;
let _BASE_HOST = location.hostname;
let _FRONT_HOST = location.hostname;
let _BASE_PORT = location.port;
let _FRONT_PORT = location.port;


/**
 * 혀재 주소가 개발주소일 경우 정의
 * @type {string}
 */
//alert( _BASE_HOST.split(".")[1] + "." + _BASE_HOST.split(".")[2] )
const INNER_HOST = "hwlms.com";
if ( _BASE_HOST === "localhost" || _BASE_HOST === "127.0.0.1" || _BASE_HOST.split(".")[1] + "." + _BASE_HOST.split(".")[2] === INNER_HOST ) {
// if ( _BASE_HOST === "localhost" || _BASE_HOST === "127.0.0.1" || _BASE_HOST === INNER_HOST ) {
	_BASE_PROTOCOL = "http:";
	_BASE_HOST = "localhost";
	// 포트는 실제 브라우저 포트 사용 (location.port가 이미 설정되어 있음)
	// _BASE_PORT는 location.port로 이미 초기화되어 있으므로 변경 불필요

	// LOCAL 환경
	// _BASE_HOST = INNER_HOST;
}
// alert( _BASE_HOST );

let _API_URL = _BASE_PROTOCOL + "//" + _BASE_HOST;
let _CMS_URL = _BASE_PROTOCOL + "//" + _BASE_HOST;
if ( $.trim(_BASE_PORT) !== "" ) {
	_API_URL += ":" + _BASE_PORT;
	_CMS_URL += ":" + _BASE_PORT;
}
_API_URL += "/api";
_CMS_URL += "/hwmanager";


/**
 * 프론트 주소 정의
 * @type {string}
 * @private
 */
let _FRONT_URL = _BASE_PROTOCOL + "//" + _FRONT_HOST;
if ( $.trim(_BASE_PORT) !== "" ) {
	_FRONT_URL += ":" + _FRONT_PORT;
}


/**
 * 기본 주소 정의
 * @type {string}
 * @private
 */
let _CSS_URL = _BASE_PROTOCOL + "//" + _BASE_HOST;
let _BASE_URL = _BASE_PROTOCOL + "//" + _BASE_HOST;
if ( location.port !== '' ) {
	_BASE_URL += ":" + location.port;
	_CSS_URL += ":" + _BASE_PORT;
}


if ( $.trim(_BASE_PORT) !== "" ) {
	console.log("_BASE_PROTOCOL ::::: " + _BASE_PROTOCOL)
	console.log("_BASE_HOST ::::: " + _BASE_HOST)
	console.log("_BASE_URL ::::: " + _BASE_URL)
// console.log("_BASE_PORT ::::: " + _BASE_PORT)
	console.log("_FRONT_URL ::::: " + _FRONT_URL)
// console.log("_FRONT_PORT ::::: " + _FRONT_PORT)
	console.log("_API_URL ::::: " + _API_URL)
}

// localhost 환경 감지
const isLocalhost = location.hostname === "localhost" || location.hostname === "127.0.0.1" || location.hostname === "192.168.0.77" || location.hostname === "192.168.0.200";

// 디버깅: 환경 감지 로그 출력
console.log("=== 환경 감지 디버깅 ===");
console.log("location.hostname:", location.hostname);
console.log("isLocalhost:", isLocalhost);
console.log("========================");

// 카카오 로그인 키 설정 (환경별로 분기)
const KAKAO_LOGIN_KEY = isLocalhost 
	? "f256e142ab984bdf931c4040c92c3aa5"  // localhost용 JavaScript 키
	: "f4fe96d6fed7d48b3b9ec63f1cbe24c5";  // 운영/테스트용 JavaScript 키

const KAKAO_REST_API_LOGIN_KEY = isLocalhost
	? "62e7dbd4c8f964de47f7946f0eceb41c"  // localhost용 REST API 키
	: "4b9c1580e7cbf4bed66eaf372109ed1f";  // 운영/테스트용 REST API 키

// 네이버 로그인 키 설정 (환경별로 분기)
const NAVER_LOGIN_KEY = isLocalhost
	? "gA48HBvQwIzr4QuCvBHI"  // localhost용 Client ID
	: "qFDEQxXzXziHz8pT4Y69";  // 운영/테스트용 Client ID

const NAVER_LOGIN_SECRET = isLocalhost
	? "Jxn5QMZUoj"  // localhost용 Client Secret
	: "BBUSJCVbCO";  // 운영/테스트용 Client Secret

export default {

	FRONT_URL : _FRONT_URL,
	BASE_URL : _BASE_URL,
	CSS_URL : _CSS_URL,
	API_URL : _API_URL,
	_CMS_URL : _CMS_URL,

	KAKAO_LOGIN_KEY: KAKAO_LOGIN_KEY,
	KAKAO_REST_API_LOGIN_KEY: KAKAO_REST_API_LOGIN_KEY,
	KAKAO_LOGIN_RETURN: location.origin + "/member/sns/kakaoReturn",
	KAKAO_IOS_LOGIN_RETURN: location.origin + "/member/sns/kakaoIOSReturn",

	NAVER_LOGIN_KEY: NAVER_LOGIN_KEY,
	NAVER_LOGIN_SECRET: NAVER_LOGIN_SECRET,
	// location.origin 사용 (쿼리 파라미터 영향 방지, getSubdomainWithURLString은 hostname만 사용하므로 location.origin으로 충분)
	NAVER_LOGIN_RETURN: location.origin.replace(webUtils.getSubdomainWithURLString(location.origin), "www") + "/member/sns/naverReturn" + "/" + webUtils.getSubdomainWithURLString(location.origin),
	NAVER_IOS_LOGIN_RETURN: location.origin.replace(webUtils.getSubdomainWithURLString(location.origin), "www") + "/member/sns/naverIOSReturn" + "/" + webUtils.getSubdomainWithURLString(location.origin),


	APPLE_LOGIN_RETURN: (":" + location.port === ":" ? location.origin : location.origin.replace(":" + location.port, "")).replace(webUtils.getSubdomainWithURLString(location.origin), "www"),

	// 공통 및 코드
	COMMON_CODE: _API_URL + "/commons/code",
	DP_KEYWORD: _API_URL + "/keywords",

	// DISPLAY + CACHE
	DISPLAY: _API_URL + "/display",
	DISPLAY_CMS_POPUP: _CMS_URL + "/popup",
	DISPLAY_POPUP: _API_URL + "/display/popup",


	// 로그인 및 세션
	SESSION: _API_URL + "/session",


	// SNS 관련
	SNS_APPLE: _API_URL + "/sns/apple",


	// 회사
	CO_INFO: _API_URL + "/coinfos",

	// 회원가입
	CO_ACCOUNT: _API_URL + "/coaccounts",

	// 파일 공통
	FILES: _API_URL + "/file",
	FILES_SHOW: _API_URL + "/file/show/",
	FILES_DOWN: _API_URL + "/file/download/",
	FILES_PLAY: _API_URL + "/file/play/",

	// 게시판
	BOARDS: _API_URL + "/boards",
	BOARD_COMMENTS: _API_URL + "/boards/comments",
	BOARD_LIKE: _API_URL + "/boards/like",
	BOARD_CAUTION: _API_URL + "/boards/caution",
	BOARD_FILES: _API_URL + "/boards/file",
	BOARD_FILES_SHOW: _API_URL + "/boards/file/show/",
	BOARD_FILES_DOWN: _API_URL + "/boards/file/download/",
	BOARD_FILES_PLAY: _API_URL + "/boards/file/play/",


	// SHOP
	SHOP_GOODS: _API_URL + "/goods",
	SHOP_ORDER: _API_URL + "/order",
	SHOP_PG: _API_URL + "/pg",
	SHOP_FILE_SHOW: _API_URL + "/shop/file/show/",
	SHOP_FILES_DOWN: _API_URL + "/shop/file/download/",


	// 교육메인
	EDU_MAIN: _API_URL + "/edu/main",
	EDU_STUDENT: _API_URL + "/edu/student",
	EDU_CONTENT: _API_URL + "/edu/content",
	EDU_QUESTION: _API_URL + "/edu/question",
	EDU_ANSWER: _API_URL + "/edu/answer",
	EDU_MINE: _API_URL + "/edu/mine",
	EDU_FILE: _API_URL + "/edu/file",
	EDU_FILE_SHOW: _API_URL + "/edu/file/show/",
	EDU_FILE_DOWN: _API_URL + "/edu/file/download/",
	EDU_FILE_PLAY: _API_URL + "/edu/file/play/",


	// 교육과정
	EDU_COURSE: _API_URL + "/edu/course",

	// 라이선스
	LICENSE: _API_URL + "/license",
	PRODUCT: _API_URL + "/product",

	// 정적 페이지
	STATIC_PAGE: _API_URL + "/pages/",


	// 내정보
	MINE: _API_URL + '/mypage/info',
	CART: _API_URL + '/mypage/cart',

	OAUTH: _API_URL + '/oauth'
}
//export default APIs;
